const SiteService = function () {
  this.addSponsorClass = function () {};
};

export default new SiteService();
